import { authContent } from '@/lib/api';

/**
 * get turbo combo recommendations by disciplines ids
 * @param {Object} params - object with parameters for the request
 * @param {Array<String>} params.disciplineIds - array of disciplines ids
 * @param {Array<String>} [params.tournamentIds] - array of tournaments ids
 */
function getTurboComboRecommendations({ disciplineIds = [], tournamentIds = [] }) {
  return authContent.get(`/recommendations/turbo-combo`, {
    params: {
      disciplineIds: disciplineIds.toString(),
      tournamentIds: tournamentIds.toString(),
    },
  });
}

/**
 * get express recommendations by disciplines ids
 * @param {Object} params - object with parameters for the request
 * @param {Array<String>} params.disciplineIds - array of disciplines ids
 * @param {Array<String>} [params.tournamentIds] - array of tournaments ids
 */
function getExpressRecommendations({ disciplineIds = [], tournamentIds = [] }) {
  return authContent.get(`/recommendations/express`, {
    params: {
      disciplineIds: disciplineIds.toString(),
      tournamentIds: tournamentIds.toString(),
    },
  });
}

/**
 * get bet builder recommendations by disciplines ids
 * @param {Object} params - object with parameters for the request
 * @param {Array<String>} params.disciplineIds - array of disciplines ids
 * @param {Array<String>} [params.excludeIds] - array of recommendation ids to exclude
 */
function getBetBuilderRecommendations({ disciplineIds = [], excludeIds = [], pageSize = 50 }) {
  return authContent.get(`/recommendations/bet-builder`, {
    params: {
      disciplineIds: disciplineIds.toString(),
      excludeIds: excludeIds.toString(),
      pageSize,
    },
  });
}

/**
 * get recommendation express tips by disciplines ids and events ids
 * this data is taken based on the outcomes that the user added to the coupon
 * @param {Object} params
 * @param {Array<String>} params.disciplinesIds - array of disciplines ids
 * @param {Array<String>} params.eventsIds - array of events ids
 * @param {Number} params.pageNumber - page number
 * @param {Number} params.pageSize - page size
 */
function getExpressRecommendationTips({
  disciplinesIds = [],
  eventsIds = [],
  pageNumber = 1,
  pageSize = 2,
}) {
  return authContent.get(`/recommendations/outcomes`, {
    params: {
      disciplineIds: disciplinesIds.toString(),
      eventIds: eventsIds.toString(),
      pageNumber,
      pageSize,
    },
  });
}

/**
 * get swipe bets by disciplines ids
 * @param {Object} params
 * @param {Array<String>} params.disciplinesIds - array of disciplines ids
 * @param {Number} params.pageNumber - page number
 * @param {Number} params.pageSize - page size
 * @param {Array<String>} [params.excludeIds] - array of excluded ids
 */
function getSwipeBets({ disciplinesIds = [], excludeIds = [], pageNumber = 1, pageSize = 3 }) {
  return authContent.get(`/recommendations/swipe-bets`, {
    params: {
      disciplineIds: disciplinesIds.toString(),
      excludeIds: excludeIds.toString(),
      pageNumber: pageNumber,
      pageSize: pageSize,
    },
  });
}

export {
  getTurboComboRecommendations,
  getExpressRecommendations,
  getBetBuilderRecommendations,
  getExpressRecommendationTips,
  getSwipeBets,
};
